import { SetStateAction, useCallback, useRef, useState } from 'react';
import { isFunction } from 'lodash';

type Dispatch<A> = (value: A) => A;

const useLatestState = <S>(
  initialState: S | (() => S),
): [S, Dispatch<SetStateAction<S>>] => {
  const [state, setState] = useState(initialState);
  const ref = useRef(state);

  // return the updated state
  const _setState = useCallback((newState: SetStateAction<S>) => {
    setState(newState);
    if (isFunction(newState)) {
      ref.current = newState(ref.current);
    } else {
      ref.current = newState;
    }
    return ref.current;
  }, []);

  return [state, _setState];
};

export default useLatestState;
